// extracted by mini-css-extract-plugin
export default {"studioRoot":"OoH0yt"};